import { useCallback, useEffect, useState } from "react"
import { PriceModeDefaultValues, PriceModeSettingsSchema, PriceModeSettingsType } from "./validation.priceMode"

import useAppForm from "~/hooks/useAppForm"
import { useCamp } from "~/api2/hooks/useCamp"

export default function usePriceModeSelector() {
  const {
    index: { data: camp, refetch: refetchCamp, isLoading: isLoadingCamp, isFetching: isFetchingCamp },
    update: { mutate: saveInvoices, isPending: isPendingSaveInvoices },
  } = useCamp()
  const [defaultValues, setDefaultValues] = useState<PriceModeSettingsType>(PriceModeDefaultValues)

  const isLoadingData = isLoadingCamp || isFetchingCamp || !camp

  const reactHookForm = useAppForm<PriceModeSettingsType>({
    defaultValues,
    schema: PriceModeSettingsSchema,
  })

  useEffect(() => {
    reactHookForm.reset(defaultValues)
  }, [defaultValues])

  useEffect(() => {
    handleSetDefaultValues()
  }, [camp])

  const handleSetDefaultValues = useCallback(() => {
    if (camp) {
      const newDefaults: PriceModeSettingsType = {
        price_mode: camp?.price_mode,
      }
      setDefaultValues(newDefaults)
    }
  }, [camp])

  const onSubmit = useCallback(
    (data: PriceModeSettingsType) => {
      const updatedData = {
        ...camp,
        ...data,
      }

      saveInvoices(updatedData, {
        onSuccess: () => {
          setDefaultValues(data)
          refetchCamp()
        },
      })
    },
    [camp, saveInvoices, refetchCamp],
  )

  return { reactHookForm, onSubmit, handleSetDefaultValues, isPendingSaveInvoices, isLoadingData }
}
